/* eslint-disable react/prop-types */
// import { updateOrderType } from "@/redux/slice/take-order-slice/order-slice";
import { changeOrderTypeApi } from "@/api/take-order/take-order";
import { setOrderData } from "@/redux/slice/take-order-slice/order-slice";
import { setSelectedCustomer } from "@/redux/slice/take-order-slice/selected-customer-slice";
import { setDeliveryInfo } from "@/redux/slice/take-order-slice/delivery-slice";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaXmark } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { getOrderCustomerName, getOrderCustomerPhone } from "@/lib/utils";


function ConvertOrder({setConvertOrder, setDeliveryInfoPage}) {
    const { orderData } = useSelector((state) => state.takeOrder.order);
    const dispatch = useDispatch(); 
    const [ orderType, setOrderType ] = useState(orderData?.order_type || "0");

    function handleConvert() {

        // console.log(orderType);
        // dispatch(updateOrderType(orderType));
        changeOrderTypeApi(orderData?.id, { OrderType: orderType }).then((res) => {
            // console.log(res);
            if(res?.status == "success" ) {
                toast.success("Order type changed successfully");
                dispatch(setOrderData(res?.data));

                if(orderType == "delivery"){
                    const cust = res?.data?.customer || orderData?.customer;
                    const custFullName = cust?.full_name || res?.data?.customer_full_name || orderData?.customer_full_name;
                    const custNumber = cust?.number || res?.data?.customer_number || orderData?.customer_number;
                    const activeAddr = cust?.active_address || cust?.addresses?.[0] || res?.data?.delivery || orderData?.delivery;

                    if (cust || custFullName || custNumber) {
                        dispatch(setSelectedCustomer({
                            id: cust?.id || null,
                            unique_id: cust?.unique_id,
                            full_name: custFullName || "",
                            number: custNumber || "",
                            email: cust?.email,
                            active_address: activeAddr || cust?.active_address,
                            addresses: cust?.addresses || [],
                            points: cust?.points || 0,
                            points_value: cust?.points_value || 0,
                        }));
                    }

                    if (activeAddr) {
                        dispatch(setDeliveryInfo({
                            door_no: activeAddr?.door_no || "",
                            address: activeAddr?.address || "",
                            city: activeAddr?.city || "",
                            state: activeAddr?.state || "",
                            postal_code: activeAddr?.postal_code || "",
                            deliveryNote: activeAddr?.delivery_note || activeAddr?.note || activeAddr?.deliveryNote || "",
                            deliveryDistance: activeAddr?.delivery_distance || "",
                            deliveryDuration: activeAddr?.delivery_duration || "",
                        }));
                    }

                    setDeliveryInfoPage(true);
                }

                setConvertOrder(false);
            }
                
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <div className=" w-[600px] h-[400px] bg-color2 p-6 rounded-md border-4 border-color3 relative">
            <button onClick={()=> setConvertOrder(false)} className=" absolute top-0 right-0 text-color8 float-right text-2xl p-2"><FaXmark/></button>
            <h1 className=" -mt-4 text-center text-xl font-semibold">Check Out</h1>
            <div className=" w-full h-full mt-5">
                <div className=" w-full bg-color3 p-2 flex justify-between">
                    <div>
                        <div>
                            <span className=" font-semibold">Order ID: </span>
                            <span>{orderData?.id}</span>
                        </div>
                        <div>
                            <span className=" font-semibold">Customer Name: </span>
                            <span>{getOrderCustomerName(orderData, "Unknown")}</span>
                        </div>
                        <div>
                            <span className=" font-semibold">Phone: </span>
                            <span>{getOrderCustomerPhone(orderData, "-")}</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span className=" text-color6 font-semibold">{(orderData?.order_type == "pickup")? "Pickup" : (orderData?.order_type == "delivery")? "Delivery" :  (orderData?.order_type == "in_house")? "In House" :  (orderData?.order_type == "table")? "Table" : "" }</span>
                        </div>
                        <div>
                            <span className=" font-semibold">Date: </span>
                            <span>{new Date(orderData?.created_at).toLocaleDateString()}</span>
                        </div>
                    </div>
                </div>
                <div className=" w-full mt-8 ">
                    <div className=" w-full py-3">
                        <span className=" py-1 text-lg font-semibold">Convert To</span>
                    </div>
                    <select onChange={(e)=> setOrderType(e.target.value)} value={orderType} name="convertTo" id="convertTo"  className=" w-full py-2 px-2 bg-color2 border-2 border-color3 outline-none rounded-md">
                        <option value="0">Select Option</option>
                        <option value="pickup">Pickup</option>
                        <option value="in_house">In House</option>
                        <option value="delivery">Delivery</option>
                    </select>
                </div>

            <div className=" mt-10 flex gap-4">
                <button onClick={()=> setConvertOrder(false)}  className=" w-full p-2 bg-color8 font-bold rounded-md flex flex-col items-center justify-center gap-1">
                    <span>Cancel </span>
                </button>
                <button onClick={handleConvert}  className=" w-full p-2 bg-color7 font-bold rounded-md flex flex-col items-center justify-center gap-1">
                    <span>Confirm </span>
                </button>
            </div>
            </div>
            
        </div>
    )
}

export default ConvertOrder;